export default ({
    onClick,
    onCancel,
    button
}) => {
    return (
        <div className="verification-page">
            <div className="verification-alert">
                <div className="icon">✅</div>
                <div className="title">Your account is verified</div>
                <div className="text">Your account is fully verified! You can take full advantage of a verified account!</div>
            </div>

            <div className="verification-limits">
                <div className="block-title">Advantages</div>
                <div className="limit"><div className="title">🎁 Personal activation of the voucher</div></div>
                <div className="limit"><div className="title">👨‍💻 Priority support</div></div>
                <div className="limit">
                    <div className="title">💰 Cashouts limit</div>
                    <div className="value">$5,000 / day</div>
                </div>
            </div>

            <div className="verification-buttons">
                <div className="button" onClick={onCancel}>Okay, thanks!</div>
            </div>
        </div>  
    )
}